<div class="landing-page-container" data-cy="landing-page">
  <div class="content-block fit-height landing-content hide-scrollbars">
    <div class="welcome-header">
      <div class="logo-title-container">
        <h1 class="welcome-title" data-cy="welcome-title">Welcome to</h1>
        <img src="assets/arpio-logo-black.png" alt="ARPIO" class="arpio-logo" data-cy="arpio-logo" />
      </div>
      <p class="welcome-subtitle" data-cy="welcome-subtitle">
        Get started by creating your first application, configuring your account, or managing team access.
      </p>
    </div>

    <div class="action-cards" data-cy="action-cards">
      <!-- Card 1: Create an Arpio Application -->
      <div class="action-card" (click)="navigateToCreateApplication()" data-cy="card-create-application">
        <div class="card-content">
          <div class="card-header">
            <h3 class="card-title" data-cy="card-title-create-app">Create an Arpio Application</h3>
          </div>
          <p class="card-description">
            Define which cloud resources to protect with Arpio's automated disaster recovery.
          </p>
        </div>
        @if (applicationCreated) {
          <div class="visited-indicator" [class.pulse]="applicationCreatedPulse">
            <svg lucideCheck class="visited-check" [strokeWidth]="2.5"></svg>
          </div>
        }
      </div>

      <!-- Card 2: Review Account Settings -->
      <div class="action-card" (click)="navigateToAccountSettings()" data-cy="card-account-settings">
        <div class="card-content">
          <div class="card-header">
            <h3 class="card-title" data-cy="card-title-settings">Review Account Settings</h3>
          </div>
          <p class="card-description">
            Set up a retention policy, manage identity providers, and create API keys to customize Arpio.
          </p>
        </div>
        @if (accountSettingsComplete) {
          <div class="visited-indicator" [class.pulse]="accountSettingsCompletePulse">
            <svg lucideCheck class="visited-check" [strokeWidth]="2.5"></svg>
          </div>
        }
      </div>

      <!-- Card 3: Manage Team Access -->
      <div class="action-card" (click)="navigateToTeamAccess()" data-cy="card-team-access">
        <div class="card-content">
          <div class="card-header">
            <h3 class="card-title" data-cy="card-title-team">Manage Team Access</h3>
          </div>
          <p class="card-description">Control who can view, manage, test, and recover your applications.</p>
        </div>
        @if (accessManagementComplete) {
          <div class="visited-indicator" [class.pulse]="accessManagementCompletePulse">
            <svg lucideCheck class="visited-check" [strokeWidth]="2.5"></svg>
          </div>
        }
      </div>
    </div>

    @if (applicationCreated) {
      <div class="ready-button-container">
        <div>
          <p class="text-center">
            Thank you for viewing the Arpio introduction experience. If you are ready to dismiss this page, please click
            <strong>I'm Ready</strong> below.
          </p>
        </div>
        <button class="ready-button" (click)="dismissIntro()" data-cy="ready-button">I'm Ready</button>
      </div>
    }
  </div>
  <div class="help-section" data-cy="help-section">
    <h4 class="help-title">Need help getting started?</h4>
    <div class="help-links">
      <a class="help-link" (click)="openDocs()" data-cy="link-docs">View Arpio Docs</a>
      <span class="help-separator">|</span>
      <a class="help-link" (click)="openSupport()" data-cy="link-support">Contact Support</a>
    </div>
    <!-- DEV ONLY: Uncomment for testing
    <div style="margin-top: 20px;">
      <a class="help-link" (click)="resetOnboarding()" style="color: #999; font-size: 12px;">[DEV] Reset Onboarding State</a>
    </div>
    -->
  </div>
</div>
